export interface ProjectAdminMenuItem {
  label: string;
  value: string;
  type: ProjectAdminMenuType;
  sequenceOrder: number;
}

export enum ProjectAdminMenuType {
  GENERAL = 'GENERAL',
  USER_ADMIN = 'USER_ADMIN',
  FEATURES = 'FEATURES',
  PROJECT_ADMIN = 'PROJECT_ADMIN',
  TOOLROOMS = 'TOOLROOMS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  UNITS_VALUES = 'UNITS_VALUES',
  SYNC = 'SYNC',
}

export interface ProjectAdminListProps {
  isListCollapsed: boolean;
  onToggleCollapse: () => void;
}
